"use client";
import { useState, useEffect } from "react";
import { Icon } from "@zapier/zinnia-icons";
import { Text } from "@zapier/design-system";

export default function AlertFooter() {
  const [isVisible, setIsVisible] = useState(false);

  // Get configuration from environment variables
  const alertMessage = process.env.NEXT_PUBLIC_ALERT_MESSAGE;
  const alertEnabled = process.env.NEXT_PUBLIC_ALERT_ENABLED === "true";
  const alertId = process.env.NEXT_PUBLIC_ALERT_ID || "default-alert";
  const alertExpiryDays = parseInt(
    process.env.NEXT_PUBLIC_ALERT_EXPIRES_DAYS || "3",
    10,
  );
  const alertLink = process.env.NEXT_PUBLIC_ALERT_LINK;
  const alertLinkText = process.env.NEXT_PUBLIC_ALERT_LINK_TEXT || "Learn more";

  // Generate localStorage key based on alert ID
  const ALERT_DISMISS_KEY = `ticketcopilot-alert-${alertId}`;

  useEffect(() => {
    try {
      // Check if alert was dismissed
      const dismissedData = localStorage.getItem(ALERT_DISMISS_KEY);
      if (dismissedData) {
        const { timestamp } = JSON.parse(dismissedData);
        const expiryTime = timestamp + alertExpiryDays * 24 * 60 * 60 * 1000;

        // If expired, show alert again
        if (Date.now() > expiryTime) {
          localStorage.removeItem(ALERT_DISMISS_KEY);
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      } else {
        setIsVisible(true);
      }
    } catch (error) {
      // If localStorage is not available, show the alert
      console.error("Error accessing localStorage:", error);
      setIsVisible(true);
    }
  }, [ALERT_DISMISS_KEY, alertExpiryDays]);

  const handleDismiss = () => {
    try {
      localStorage.setItem(
        ALERT_DISMISS_KEY,
        JSON.stringify({
          timestamp: Date.now(),
        }),
      );
    } catch (error) {
      console.error("Error saving to localStorage:", error);
    }
    setIsVisible(false);
  };

  // Don't render if not enabled or no message
  if (!alertEnabled || !alertMessage || !isVisible) return null;

  return (
    <div
      style={{
        backgroundColor: "#f7f6fd",
        borderTop: "1px solid #503ebd",
      }}
    >
      <div
        style={{
          maxWidth: "720px",
          margin: "0 auto",
          padding: "8px 24px",
          display: "flex",
          alignItems: "flex-start",
          gap: "8px",
          position: "relative",
        }}
      >
        <div
          style={{
            color: "#503ebd",
            display: "flex",
            alignItems: "center",
            paddingTop: "2px",
          }}
        >
          <Icon name="alertInfoFill" size="18px" />
        </div>
        <Text type="MinimalPrint1" style={{ flex: 1 }}>
          {alertMessage}
          {alertLink && (
            <>
              {" "}
              <a
                href={alertLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#695be8", textDecoration: "underline" }}
              >
                {alertLinkText}
              </a>
            </>
          )}
        </Text>
        <button
          onClick={handleDismiss}
          style={{
            background: "none",
            border: "none",
            color: "#503ebd",
            cursor: "pointer",
            fontSize: "18px",
            padding: "0",
            marginLeft: "8px",
            lineHeight: "1",
            fontWeight: "300",
          }}
          aria-label="Dismiss alert"
        >
          ×
        </button>
      </div>
    </div>
  );
}
